import styled from 'styled-components';

import { useClientEnvironment } from '@hooks/clientEnvironment';

export type LogoProps = {
  style?: React.CSSProperties;
  onClick?: () => void;
  fontSize?: number;
  sandboxLogoUrl?: string;
};

const INITIAL_FONT_SIZE = 24;

const LogoText = styled.span`
  color: ${({ theme }) => theme.palette.primary[0]};
  font-family: 'Montserrat', sans-serif;
  font-weight: ${({ theme }) => theme.palette.textFontWeight[0]};
`;

const SaaSLogo = ({
  fontSize = INITIAL_FONT_SIZE,
  onClick,
  style,
  sandboxLogoUrl,
}: LogoProps): JSX.Element => {
  const { data: clientEnvironment } = useClientEnvironment();
  const { name: clientName, logo_url: clientLogoUrl } = clientEnvironment || {};

  const logoStyle: React.CSSProperties = {
    fontSize,
    cursor: onClick ? 'pointer' : 'auto',
    textDecoration: 'none',
    maxWidth: 300,
    maxHeight: 48,
    ...style,
  };
  const logoTextStyle: React.CSSProperties = {
    fontSize,
    cursor: onClick ? 'pointer' : 'auto',
    textDecoration: 'none',
    maxWidth: 300,
    ...style,
  };

  const currentClientLogoUrl = sandboxLogoUrl || clientLogoUrl;

  return currentClientLogoUrl ? (
    <img
      src={currentClientLogoUrl}
      style={logoStyle}
      alt={`${clientName}-logo`}
    />
  ) : (
    <LogoText style={logoTextStyle}>{`${clientName} Casting`}</LogoText>
  );
};

export default SaaSLogo;
